
export default {
  data() {
    return {
      bidangCSRChart: [],  // data dari backend
      bidangCSR: [],
      mitra: null,
      tipe: null,
      perusahaan: null,
      indikator: {
        pengajuan: 12,
        diterima: 7,
        ditolak: 3,
        proses: 2
      },

      widgetStatus: {
        total_pengajuan: 0,
        diterima: 0,
        ditolak: 0,
        diproses: 0
      },
      
    }
  },
  mounted() {
    const get_profile = JSON.parse(localStorage.profile);

    this.tipe = Number(get_profile.profile.db_csrkonsel);

    this.mitra = {
      id: get_profile._id,
      nama: get_profile.profile.nama,
      username: get_profile.username,
      email: get_profile.email,
      telp: get_profile.profile.telp,
      alamat: get_profile.profile.alamat,
      pic: get_profile.profile.pic,
      file_name: get_profile.profile.file_name // logo perusahaan
    };

    this.getMitra(get_profile._id);


    this.loadWidgetAndChart();
  },
  methods: {

    

    async loadWidgetAndChart() {
    try {
      // Ambil data widget dari backend
      const res = await fetch(this.$store.state.url.DASHBOARD + "statusPengajuan", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "authorization": "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ users_id: this.mitra.id })
      });

      const data = await res.json();

      if (data.data) {
        // Update widgetStatus
        this.widgetStatus = data.data;
      }

      // Setelah data widget tersedia, render pie chart
      this.chartPieCSR();

    } catch (err) {
      console.error('Gagal ambil data widget:', err);
    }
  },

    // Ambil jumlah pengajuan untuk widget
    getWidgetStatus(users_id) {
      fetch(this.$store.state.url.DASHBOARD + "statusPengajuan", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          "authorization": "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ users_id })
      })
      .then(res => res.json())
      .then(res => {
        if(res.data) {
          this.widgetStatus.total_pengajuan = res.data.total_pengajuan;
          this.widgetStatus.diterima = res.data.diterima;
          this.widgetStatus.ditolak = res.data.ditolak;
          this.widgetStatus.diproses = res.data.diproses;
        }
      })
      .catch(err => console.error('Gagal ambil data widget:', err));
    },

    getMitra(userId) {
      fetch(this.$store.state.url.DATA_MITRA + "viewByUser", {
        method: 'POST',
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ users_id: userId })
      })
      .then(res => res.json())
      .then(res => {
        if (res.data) {
          // kalau backend return array
          this.mitra = Array.isArray(res.data) ? res.data[0] : res.data;
          // panggil widget status pakai users_id dari mitra
      this.getWidgetStatus(this.mitra.users_id || userId);
      this.getBidangCSR();
        }
      })
      .catch(err => {
        console.error('Gagal ambil data perusahaan:', err);
      });
    },
    chartPieCSR() {
  Highcharts.chart('chartPieCSR', {
    chart: { type: 'pie', backgroundColor: 'transparent' },
    title: { text: 'Status Pengajuan Force Majeure' },
    tooltip: { pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>' },
    plotOptions: {
      pie: { 
        allowPointSelect: true, 
        cursor: 'pointer', 
        dataLabels: { enabled: false }, 
        showInLegend: true 
      }
    },
    series: [{
      name: 'Persentase',
      colorByPoint: true,
      data: [
       
        { name: 'Diterima', y: this.widgetStatus.diterima, color: '#43a047' },
        { name: 'Ditolak', y: this.widgetStatus.ditolak, color: '#e53935' },
        { name: 'Proses', y: this.widgetStatus.diproses, color: '#ffb300' }
      ]
    }]
  });
},
getBidangCSR() {
  const users_id = this.mitra.users_id;
  console.log('users_id dikirim ke backend:', users_id); // harus ada value
  fetch(this.$store.state.url.DASHBOARD + "bidangCSR", {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({ users_id })
  })
  .then(res => res.json())
  .then(res => {
    console.log("Data dari backend bidangCSR:", res.data);
    if(res.data) {
      this.bidangCSR = res.data;
      this.chartByBidangCSR(); // panggil chart
    }
  })
  .catch(err => console.error(err));
},

chartByBidangCSR() {
  if (!this.bidangCSR || this.bidangCSR.length === 0) return;

  Highcharts.chart('chartByBidangCSR', {
    chart: { type: 'column', backgroundColor: 'transparent' },
    title: { text: 'Pengajuan Berdasarkan Bidang CSR' },
    xAxis: {
      categories: this.bidangCSR.map(b => b.nama_bidang), // <-- ganti nama_bidang -> uraian
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: { text: 'Jumlah Pengajuan' }
    },
    tooltip: {
      shared: true,
      valueSuffix: ' pengajuan'
    },
    plotOptions: {
      column: { colorByPoint: true }
    },
    series: [{
      name: 'Jumlah Pengajuan',
      data: this.bidangCSR.map(b => b.total_pengajuan), 
      color: '#1e88e5'
    }]
  });
},


  }
}
